import {
  Avatar,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import Lightbox from 'react-18-image-lightbox'

import { PRIMARY_COLORS, WARNING_COLORS } from 'asterX-UI'
import {
  AttachmentIcon,
  CheckBoxIcon,
  CheckBoxOutlineBlankIcon,
  CloseIcon,
  SearchIcon
} from 'asterX-UI/Icons'
import AutoCompleteField from 'asterX-UI/Inputs/AutoCompleteField'
import { LoaderBackdrop } from 'asterX-UI/Loaders'

import { useAuthStore } from 'context/AuthStore'
import { useSelectionStore } from 'context/SelectionStore/Manager/SelectionStoreProvider.manager'

import { CarService, SalesService } from 'lib/api'

import PageContainerDesktop from 'components/PageContainer/layout/PageContainer.desktop'

import {
  CERTIFICATE,
  COMM_DIRECTOR,
  EMPLOYEE,
  extraOptions,
  PROMO,
  TRADEIN
} from 'constants/discountTypes'
import { useResErrors } from 'hooks'
import { useModalbar } from 'modules/Modalbar'
import { Autocomplete } from '@material-ui/lab'
import { AssignmentLate } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  heading: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    marginRight: 'auto'
  },
  gap: {
    gap: 12
  },
  price: {
    padding: '3px 6px',
    backgroundColor: WARNING_COLORS['300'],
    borderRadius: 5
  },
  lupa: {
    color: PRIMARY_COLORS['700'],
    fontSize: 24,
    padding: 10,
    backgroundColor: PRIMARY_COLORS['50'],
    borderRadius: 8
  }
}))

const AttachPhoto = ({ onUpload = () => {}, disabled = false }) => {
  const { standardCheck } = useResErrors()
  const [loading, setLoading] = useState(false)
  const handleUploadFile = e => {
    const files = e.target.files
    if (files) {
      if (files.length !== 0) {
        const file = files[0]
        setLoading(true)
        SalesService.uploadFiles(file).then(res => {
          setLoading(false)
          standardCheck(res, () => {
            onUpload(res.data.fileDownloadUri)
          })
        })
      }
    }
  }
  return (
    <>
      <LoaderBackdrop loading={loading} />
      <Tooltip title="Прикрепить">
        <IconButton component="label" disabled={disabled}>
          <AttachmentIcon color="primary" />
          <input
            type="file"
            accept="image/*"
            onChange={handleUploadFile}
            hidden
          />
        </IconButton>
      </Tooltip>
    </>
  )
}

const SumDiscount = ({ value }) => {
  const styles = useStyles()

  return (
    <Box className={styles.gap} display="flex" alignItems="center">
      <Typography>Скидка</Typography>

      <Typography className={styles.price}>
        {value?.toString()?.thousandSeparator() || 0} ₸
      </Typography>
    </Box>
  )
}

const DiscountModal = ({ onClose }) => {
  const styles = useStyles()
  const { standardCheck, silentCheck } = useResErrors()
  const { enqueueSnackbar } = useSnackbar()
  const {
    authStore: { user }
  } = useAuthStore()
  const {
    store: { sale },
    funcs: { sendDiscountValue }
  } = useSelectionStore()
  const { callModalbar } = useModalbar()

  const car = sale?.selectedCarsForSale?.[0]

  const isReadOnly =
    !!car.discountValue &&
    (!!car.discountApprovedByRop || car.discountApprovedByRop === null)

  const [discountMargin, setDiscountMargin] = useState(car.discountMargin)
  const [marginReason, setMarginReason] = useState(car?.marginReason || null)
  const [selectedVin, setSelectedVin] = useState(sale?.tradeInCarVin || '')
  const [loadingCarList, setLoadingCarList] = useState(false)
  const [carList, setCarList] = useState([])
  const [photoIndex, setPhotoIndex] = useState(null)
  const [loading, setLoading] = useState(false)
  const [isCertValid, setCertValid] = useState(false)
  const [certNo, setCertNo] = useState('')
  const [error, setError] = useState('')

  const [discountPhotos, setDiscountPhotos] = useState(
    car?.discountPhotos || []
  )

  const [discountSum, setDiscountSum] = useState({})
  const arbitraryIds = Object.keys(discountSum)

  const [discountOptions, setDiscountOptions] = useState([])

  const [discounts, setDiscounts] = useState([])
  const discountCodes = discounts.map(discount => discount.discountCode)
  const discountIds = discounts.map(discount => discount.id)

  const discountAmount = discounts.reduce((sum, discount) => {
    const arbitraryDiscount = discountSum[discount.id] ?? 0
    const currentSum = discount.arbitrary
      ? arbitraryDiscount
      : discount.amountSum + (car?.price * discount.amountPercentage) / 100
    return sum + currentSum
  }, 0)

  const discountLimits = discountOptions.reduce((limit, discount) => {
    const discountLimit =
      discount.amountSum + (car?.price * discount.amountPercentage) / 100
    if (discount.arbitrary && discountLimit) limit[discount.id] = discountLimit
    return limit
  }, {})

  const discountValue =
    car?.price + discountMargin - discountAmount - car?.bonus

  const handleOpenPhotos = indx => () => setPhotoIndex(indx)

  const handleChangeDiscountAmount = event => {
    const { value, name } = event.target
    value
      ? setDiscountSum(prev => ({ ...prev, [name]: value.toString().toNum() }))
      : setDiscountSum(prev => ({ ...prev, [name]: 0 }))
  }

  const handleChangeDiscountMargin = event => {
    const { value } = event.target
    if (value === '' || value === null) return setDiscountMargin(0)
    setDiscountMargin(value.toString().toNum())
  }

  const handleChangeCertNo = event => {
    const { value } = event.target
    setCertNo(value?.toString()?.toNum())
  }

  const handleSelectTradeIn = e => {
    const { value } = e.target
    setSelectedVin(value)
  }

  const handleChangeDiscountReason = (e, val) => {
    setDiscounts(val)
    const discountCodes = val.map(discount => discount.discountCode)

    //filter out sums by selected discount
    setDiscountSum(prev =>
      Object.fromEntries(
        Object.entries(prev).filter(([id]) => discountIds.includes(id))
      )
    )

    if (
      discountCodes.some(code =>
        [CERTIFICATE, COMM_DIRECTOR, PROMO, EMPLOYEE].includes(code)
      )
    ) {
      if (discountCodes.some(code => [CERTIFICATE, PROMO].includes(code))) {
        setCertNo('')
      }
      if (discountCodes.some(code => code === CERTIFICATE)) {
        setMarginReason(null)
      }
      setDiscountPhotos([])
      return setSelectedVin('')
    }

    return setCertNo('')
  }

  const handleChangeExtraReason = event => {
    const { value } = event.target
    setMarginReason(value)

    if (value === 'OVER_SECRET_DAD') {
      setDiscountMargin(150000)
    }
  }

  const handleSearchCert = async () => {
    setLoading(true)
    await SalesService.getCertForCar(certNo).then(res =>
      standardCheck(res, () => {
        const nominal = res?.data?.length > 0 && res.data[0].nominal
        if (nominal) {
          setCertValid(true)
        } else {
          setCertValid(false)
          setError(`Сертификат не найден!`)
        }
      })
    )

    setLoading(false)
  }

  const handleSubmit = async () => {
    const overLimit = arbitraryIds.some(
      id => discountSum[id] > discountLimits[id]
    )
    if (overLimit) return

    const emptyInputs = discounts.some(
      discount => discount.arbitrary && !discountSum[discount.id]
    )
    if (emptyInputs) return

    if (!(discounts.length || discountMargin)) {
      setError('Заполните поля')
      return
    }

    if (
      discountCodes.some(code =>
        [CERTIFICATE, COMM_DIRECTOR, EMPLOYEE].includes(code)
      ) &&
      discountPhotos?.length === 0
    ) {
      setError('Необходимо загрузить фото')

      return
    }

    if (discountCodes.some(code => code === TRADEIN) && !selectedVin) {
      setError('Необходимо выбрать автомобиль')

      return
    }

    setLoading(true)

    try {
      const discountReasons = discounts.map(discount => ({
        id: discount.id,
        sum: discountSum[discount.id]
      }))

      await sendDiscountValue({
        discountMargin: discountMargin || undefined,
        certNo: (isCertValid && certNo) || undefined,
        discountReasons,
        tradeInCarVins: selectedVin ? [selectedVin] : [],
        discountPhotos,
        marginReason: marginReason || undefined
      })

      enqueueSnackbar('Запрос на скидку отправлен!', { variant: 'success' })

      onClose()
    } catch (error) {
      setError(error.message)
    }
    setLoading(false)
  }

  const onUploadPhoto = src => {
    setDiscountPhotos(prevState => [...prevState, src])
  }

  const handleChangeTradeIn = async vin => {
    if (vin?.length < 3) {
      return setLoadingCarList(false)
    }
    setLoadingCarList(true)
    await CarService.getCarList(
      {
        vin: vin,
        statusCodes: ['ppp', 'cp', 're_cp', 'available', 'reserved']
      },
      0,
      4
    ).then(res => silentCheck(res, () => setCarList(res.data.listCars)))
    setLoadingCarList(false)
  }

  useEffect(() => {
    if (error) {
      callModalbar('Внимание', error, {
        variant: 'warning',
        btnText: 'Понятно',
        onCloseAction: () => setError('')
      })
    }
  }, [callModalbar, error])

  useEffect(() => {
    const newOption = { value: 'OVER_SECRET_DAD', label: 'Овер секрет отца' }
    if (
      [
        'ALA_BESAGASH',
        'ASTANA',
        'SHYMKENT',
        'AST_KAR',
        'ALA_SUYUNBAI'
      ].includes(user?.data?.branch?.code)
    ) {
      const optionExists = extraOptions.some(
        option => option?.value === newOption?.value
      )
      if (!optionExists) {
        extraOptions.push(newOption)
      }
    }
  }, [user])

  useEffect(() => {
    if (marginReason === 'OVER_NDS')
      setDiscountMargin((car?.price - discountSum) * 0.12 || 0)
  }, [marginReason, discountSum, car?.price])

  // fetch discount options
  useEffect(() => {
    SalesService.getDiscounts().then(fetchedDiscounts => {
      const activeDiscounts = fetchedDiscounts.filter(
        discount => discount.isActive
      )
      setDiscountOptions(activeDiscounts)
    })
  }, [])

  // set already selected discounts from back
  useEffect(() => {
    const savedDiscounts = car?.discounts ?? []

    const selectedDiscounts = discountOptions.filter(opt =>
      savedDiscounts.some(discount => discount.discountId === opt.id)
    )

    const discountSum = selectedDiscounts.reduce((acc, discount) => {
      if (discount.arbitrary) {
        const match = savedDiscounts.find(d => d.discountId === discount.id)
        if (match) {
          acc[discount.id] = match.amountSum
        }
      }
      return acc
    }, {})

    setDiscounts(selectedDiscounts)
    setDiscountSum(prev => ({ ...prev, ...discountSum }))
  }, [car?.discounts, discountOptions])

  // set discount sums to limit
  useEffect(() => {
    if (!discountIds.some(id => arbitraryIds.includes(id))) {
      const defaultDiscounts = discounts.reduce((acc, { id, arbitrary }) => {
        if (arbitrary && !discountSum.hasOwnProperty(id) && discountLimits[id])
          acc[id] = discountLimits[id]
        return acc
      }, {})

      if (Object.keys(defaultDiscounts).length) {
        setDiscountSum(prev => ({ ...prev, ...defaultDiscounts }))
      }
    }
  }, [arbitraryIds, discountIds, discountLimits, discountSum, discounts])

  return (
    <PageContainerDesktop
      customHeader={
        <Box display="flex" alignItems="center">
          <Typography className={styles.heading}>Запросить скидку</Typography>
          <IconButton onClick={onClose} size={'medium'}>
            <CloseIcon />
          </IconButton>
        </Box>
      }
      className={[styles.container, styles.gap]}
    >
      <LoaderBackdrop loading={loading} />

      <Autocomplete
        multiple
        limitTags={1}
        options={discountOptions}
        value={discounts}
        onChange={handleChangeDiscountReason}
        disableCloseOnSelect
        getOptionLabel={option => option.discountName}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            <Checkbox
              icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
              checkedIcon={<CheckBoxIcon fontSize="small" />}
              checked={selected}
            />
            {option.discountName}
          </React.Fragment>
        )}
        renderInput={params => <TextField {...params} label="Скидки" />}
      />

      {discountCodes.some(code => code === TRADEIN) && (
        <AutoCompleteField
          label={'VIN Trade-In'}
          fullWidth
          value={selectedVin}
          onInput={({ target: { value } }) => handleChangeTradeIn(value)}
          onChange={handleSelectTradeIn}
          loading={loadingCarList}
          options={carList}
          valueKey={'vin'}
          labelKey={'vin'}
          name={'markaNew'}
        />
      )}

      {discountCodes.some(code => code === CERTIFICATE) && (
        <Box display="flex" alignItems="center">
          <TextField
            label={'№ сертификата'}
            fullWidth
            value={certNo}
            onChange={handleChangeCertNo}
          />
          <IconButton disabled={certNo.length === 0} onClick={handleSearchCert}>
            {loading ? (
              <CircularProgress size={'12px'} />
            ) : (
              <SearchIcon className={styles.lupa} />
            )}
          </IconButton>
        </Box>
      )}

      {discounts.some(discount => discount.arbitrary) && (
        <Grid container spacing={2}>
          {discounts
            .filter(discount => discount.arbitrary)
            .map(discount => {
              const overLimit =
                discountSum[discount.id] > discountLimits[discount.id]

              const empty = !discountSum[discount.id]

              return (
                <Grid item>
                  <TextField
                    label={discount.discountName}
                    disabled={isReadOnly}
                    name={discount.id}
                    value={
                      discountSum[discount.id]
                        ?.toString()
                        ?.thousandSeparator() || ''
                    }
                    onChange={handleChangeDiscountAmount}
                    error={overLimit || empty}
                    fullWidth
                    helperText={overLimit && 'Превышен лимит'}
                  />
                </Grid>
              )
            })}
        </Grid>
      )}

      <TextField
        label={'Причина наценки'}
        select
        fullWidth
        value={marginReason}
        onChange={handleChangeExtraReason}
      >
        {extraOptions.map(el => (
          <MenuItem key={el.value} value={el.value}>
            <ListItemText primary={el.label} />
          </MenuItem>
        ))}
      </TextField>

      <Box className={styles.gap} display="flex">
        <TextField
          fullWidth
          label={'Наценка'}
          disabled={isReadOnly}
          value={discountMargin?.toString()?.thousandSeparator() || ''}
          onChange={handleChangeDiscountMargin}
        />
        <TextField
          disabled={true}
          fullWidth
          value={discountValue?.toString()?.thousandSeparator()}
          label={isReadOnly ? 'Сумма на согласовании' : 'Новая цена'}
        />
      </Box>

      {(!!discountAmount || !!car?.bonus) && (
        <Box className={styles.gap} display="flex" alignItems="center" px={3}>
          {!!discountAmount && <SumDiscount value={discountAmount} />}
          {!!car?.bonus && (
            <Box className={styles.gap} display="flex" alignItems="center">
              <Typography>Бонусы</Typography>

              <Typography className={styles.price}>
                {car?.bonus?.toString()?.thousandSeparator() || 0} ₸
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <Box display="flex">
        <AttachPhoto onUpload={onUploadPhoto} disabled={isReadOnly} />

        {discountPhotos.length > 0 && (
          <Box display="flex" alignItems="center" px={3} className={styles.gap}>
            {discountPhotos?.map((photo, index) => (
              <Avatar
                variant="rounded"
                key={index}
                src={photo}
                onClick={handleOpenPhotos(index)}
              >
                <AssignmentLate />
              </Avatar>
            ))}
          </Box>
        )}
      </Box>

      <Box className={styles.gap} display="flex">
        <Button
          variant={'contained'}
          fullWidth
          size={'small'}
          onClick={onClose}
        >
          Отмена
        </Button>

        <Button
          fullWidth
          color={'primary'}
          variant={'contained'}
          size={'small'}
          onClick={handleSubmit}
        >
          Запросить
        </Button>
      </Box>

      {photoIndex !== null && discountPhotos?.length > 0 && (
        <Lightbox
          reactModalStyle={{
            content: { zIndex: 1400 },
            overlay: { zIndex: 1400 }
          }}
          mainSrc={discountPhotos[photoIndex]}
          nextSrc={discountPhotos[(photoIndex + 1) % discountPhotos.length]}
          prevSrc={
            discountPhotos[
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            ]
          }
          onCloseRequest={() => setPhotoIndex(null)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + discountPhotos.length - 1) % discountPhotos.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % discountPhotos.length)
          }
        />
      )}
    </PageContainerDesktop>
  )
}

export default DiscountModal
